module.exports = __webpack_public_path__ + "static/media/roosters-silhouette.01e1a9db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/roosters-silhouette.svg
// module id = 1334
// module chunks = 0